import React, { useEffect, useState, useContext } from 'react';
import Loading from '../Loading';
import { useForm } from 'react-hook-form';
import { Container, Row, Col } from 'react-bootstrap';
import TabBar from '../TabBar';
import EditProfileTabOptions from './EditProfileTabOptions';
import { useHistory } from 'react-router-dom';
import { EDIT_USER_INFO_LIST, EDIT_OFFICER_INFO_LIST } from '../../constans';
import { TabContext } from '../../context/TabContext';
import ActionContainer from './ActionContainer';
import { profileGet, userPost, officerPut, matchSettingsGet } from '../../api';
import { UserContext } from '../../context/User';
import { editedNotice, somethingWentWrongNotice } from '../UI/Notifications';

const OFFICER_EDIT_PROFILE_TAB_BAR_ITEMS = [
  {
    label: "User Info",
    value: "user_info"
  },
  {
    label: "Contracting Officer Info",
    value: "officer_info"
  }
];

const DEFAULT_INPUT_VALUES = {
  user: {
    username: "",
    email: "",
    password: "",
    user_message: false,
    user_contact: false
  },
  officer: {
    name: "",
    phone1: "",
    fax: "",
    phone2: "",
    email: "",
    city: "",
    installation: "Fort Bragg",
    county: "",
    state: "",
    zip: "",
  }
}

const REQUEST_TYPE = {
  'user_info': userPost,
  'officer_info': officerPut
}

const OfficerEditProfile = () => {
  const [active, setActive] = useState('user_info');
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit } = useForm();
  const [inputValue, setInputValue] = useState(DEFAULT_INPUT_VALUES)
  const [selectValue, setSelectValue] = useState([]);
  const [list, setList] = useState([]);
  const { user, setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();
  const [currentInfoTrigger, setCurrentInfoTrigger] = useState(false);
  const [settingId, setSettingId] = useState(null);

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Search");
    }

    setLoading(false);
  }

  const getInputCurrentUserData = (response) => {
    setInputValue({
      ...inputValue,
      user: {
        ...inputValue.user,
        username: response.username,
        user_contact: response.user_contact,
        email: response.email,
        user_message: response.user_message
      },
      officer: {
        ...inputValue.officer,
        ...response.officer
      }
    })
  }

  const currentInfoRequest = request => {
    setLoading(true)
    const user_id = user.id;

    request({user_id})
      .then(response => {
        getInputCurrentUserData(response.data);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
      })
  }

  const getMatchSettings = () => {
    matchSettingsGet()
      .then(response => {
        setInputValue({
          ...inputValue,
          settings: {
            ...response.data.settings
          }
        })
        setSettingId(response.data.id);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
      })
  }

  useEffect(() => {
    currentInfoRequest(profileGet)
  }, [currentInfoTrigger]);

  const onChangeHandler = (value, name, infoType) => {
    setInputValue({
      ...inputValue,
      [infoType]: {
        ...inputValue[infoType],
        [name]: value.value
      }
    })
  }

  const str2bool = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return value;
  }

  const onChangeSingleValue = (event, name, infoType) => {
    setInputValue({
      ...inputValue,
      [infoType]: {
        ...inputValue[infoType],
        [name]: str2bool(event.target.value)
      }
    })
  }

  const dataTransformation = params => {
    for (let prop in params) {
      if (
        params[prop] === null || 
        params[prop] === undefined ||
        prop === "password" && !params[prop]
      ) {
        delete params[prop];
      }

      if (params[prop] === 'false') {
        params[prop] = false
      } else if (params[prop] === 'true') {
        params[prop] = true
      }
    }

    return params;
  }

  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoading(true);

    const params = {
      ...data,
      installation: inputValue.officer.installation
    }

    if (active === 'user_info') delete params.installation;

    const transformedParams = dataTransformation(params);
    request(active, transformedParams)
  };
  
  const request = (active, transformedParams) => {
    REQUEST_TYPE[active](transformedParams)
      .then(response => {
        editedNotice();
        
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        setCurrentInfoTrigger(true);
        setLoading(false);
      })
  }

  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5">
              Edit Profile
            </h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <TabBar
              active={active}
              setActive={setActive}
              tabItems={OFFICER_EDIT_PROFILE_TAB_BAR_ITEMS}
            />
          </Col>
        </Row>
        <TabContext.Provider value={{
          register,
          onChangeHandler, 
          list, 
          inputValue, 
          selectValue, 
          setInputValue, 
          setSelectValue,
          onChangeSingleValue,
          getMatchSettings,
          setLoading
        }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                {active === 'user_info' && <EditProfileTabOptions inputList={EDIT_USER_INFO_LIST} />}
                {active === 'officer_info' && <EditProfileTabOptions inputList={EDIT_OFFICER_INFO_LIST} />}
              </Col>
            </Row>
            <Row>
              <Col>
                <ActionContainer 
                  active={active}
                />
              </Col>
            </Row>
          </form>
        </TabContext.Provider>
      </Container>
      {loading && <Loading />}
    </section>
  )
}

export default OfficerEditProfile;